exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-reach-dialog-overlay] {\n  z-index: 100;\n}\n", ""]);
